import { createApp } from 'vue';
import GeolocationPopup from './GeolocationPopup.vue';

let app;

initGeolocationPopupComponent();

function getPropsFromElement(el) {
  return {
    localization: JSON.parse(el.getAttribute(':localization')),
    settings: JSON.parse(el.getAttribute(':settings')),
    translations: JSON.parse(el.getAttribute(':translations')),
  };
}

function initGeolocationPopupComponent() {
  const el = document.getElementById('geolocation-popup');
  if (!el) return;

  const geolocationDelay = Number(el.getAttribute('loading-delay') || 0) * 1000;

  setTimeout(() => {
    if (app) {
      app.unmount();
      app = null;
    }

    app = createApp(GeolocationPopup, getPropsFromElement(el));
    app.mount(el);
  }, geolocationDelay);
}

window.updateGeolocationPopupComponent = initGeolocationPopupComponent;
